import { getSqlServerGuidHash, sendMetric, randomNumber, pluralForm, getWhatId, clearParamWithoutRerender, getAbTestMetrika } from "@utils";

import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";

import Share from "@Common/Share";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

//забрать оффер ид из параметра в урл

const GhostModal = inject("mainStore")(
    observer(({ mainStore, modal = {} }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");

        const [number, setNumber] = useState(5942);

        const { offerItem } = modal;
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);

        const id = offerItem && offerItem.vendor && offerItem.vendor._id ? offerItem.vendor._id : "";

        // Отслеживание нажатия кнопки Enter
        useEffect(() => {
            document.addEventListener("keyup", handlePressEnter);

            if (localStorage.getItem(id)) {
                setNumber(parseInt(localStorage.getItem(id)));
            } else {
                let num = randomNumber(5000, 25000);
                localStorage.setItem(id, num);
                setNumber(num);
            }

            return () => document.removeEventListener("keyup", handlePressEnter);
        }, []);

        useEffect(() => {
            let interval = setInterval(() => {
                let num = randomNumber(1, 10);
                localStorage.setItem(id, number + num);
                setNumber(number + num);
            }, 10000);

            return () => clearInterval(interval);
        }, [number]);

        // Событие по нажатию Enter
        const handlePressEnter = (event) => {
            if (event.code === "Enter") {
                let el = document.getElementById("button_copy");
                if (el) {
                    el.click();
                }
            }
        };

        const handleClose = () => {
            clearParamWithoutRerender(["id", "code"]);
            mainStore.setMainStore("modal", false);
            sendMetric("click_offer_button_ghost_exit", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        return offerItem ? (
            <div className={`ghost_modal`}>
                <div className="content">
                    <div className={`content__img `}>
                        <img src={offerItem.cover || offerItem.vendor.logoList || ""} />
                        <Share offer={offerItem} />
                    </div>

                    {offerItem.offerType === "leads" ? null : <div className="content__title" dangerouslySetInnerHTML={{ __html: offerItem.title }} />}
                    <div className={`content__desc`}>
                        Сегодня это предложение забрали{" "}
                        <span>
                            {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                        </span>
                    </div>
                </div>

                <div className="content__text">
                    <span className="title">
                        {offerItem?.ghostOfferConfig && offerItem.ghostOfferConfig.textAnswer ? offerItem.ghostOfferConfig.textAnswer : "Как только предложение станет доступным, мы направим уведомление  на указанную Вами почту "}
                    </span>
                    <div className={`promo__button`} onClick={() => handleClose(true)}>
                        Выбрать другое предложение
                    </div>
                </div>
            </div>
        ) : null;
    }),
);

export default GhostModal;
